import { to64decode } from "../app/helpers/base64";

export function getLanguageParam(name: any, language: any) {
    language = to64decode(language)
    return name[language.lang]
}

export function getLanguageCookie(file: string, language: any, getObject: boolean = false) {
    language = to64decode(language)

    let lang: any = 'en'
    if (language && language.lang) {
        lang = language.lang
    }

    return getLanguage(file, lang, getObject)
}

export function getLanguage(file: string, lang: string = 'en', getObject: boolean = false) {
    let split = file.split('/')

    let result = languages

    for (let i = 0; i < split.length; i++) {
        result = result[split[i]]
    }

    return getObject ? result : result[lang];
}

const languages: any = {

    title: {
        en: 'OnePage',
        pt: 'OnePage',
    },

    yes: {
        en: 'Yes',
        pt: 'Sim'
    },
    
    no: {
        en: 'No',
        pt: 'Não'
    },
    
    null: {
        en: '',
        pt: ''
    },

    pasteHere: {
        en: 'Paste here',
        pt: 'Colar aqui'
    },

    conclude: {
        en: "Conclude",
        pt: "Concluir"
    },

    loading: {
        en: 'Loading',
        pt: 'Carregando'
    },

    changeTo: {
        en: 'Changing to ',
        pt: 'Migrando para '
    },

    select: {
        en: 'Select',
        pt: 'Selecione'
    },

    search: {
        en: 'Search',
        pt: 'Pesquisar'
    },

    new: {
        en: 'New',
        pt: 'Novo'
    },

    is_admin_master: {
        en: 'Admin Master',
        pt: 'Administrador Master'
    },

    next: {
        en: 'Next',
        pt: 'Próximo'
    },

    back: {
        en: 'Back',
        pt: 'Voltar'
    },

    date: {
        month_year: {
            en: 'month/year',
            pt: 'mês/ano'
        },
    },

    error: {
        onlyPng: {
            en: "Only PNG, JPG and JPEG is accepted",
            pt: "Apenas PNG, JPG e JPEG são aceitos"
        },
        maxSizeBytes: {
            en: 'Image size too large!',
            pt: 'Tamanho da imagem muito grande!',
        },
        invalidStartDate: {
            en: 'Invalid start date!',
            pt: 'Data inicial inválida!'
        },
        access_restriction: {
            en: 'You do not have permission to access this node',
            pt: 'Você não tem permissão para acessar este nó'
        },
        invalid_token: {
            en: 'Your session has expired. Please log in again.',
            pt: 'Sua sessão expirou. Por favor, faça login novamente.'
        },
    },

    statusSystem: {
        en: 'System status',
        pt: 'Status do sistema'
    },

    mandatoryField: {
        en: 'Please fill in the required fields: ',
        pt: 'Por favor preencha os campos obrigatórios: '
    },

    SameSeniorityLevel: {
        en: 'It is not possible to save seniorities with equal levels',
        pt: 'Não é possível salvar senioridades com niveis iguais'
    },

    FteNull: {
        en: 'Cannot save empty FTE values',
        pt: 'Não é possível salvar valores FTE vazios'
    },

    LevelNull: {
        en: 'Cannot save empty Level values',
        pt: 'Não é possível salvar valores de Nível vazios'       
    },

    fillOnePermission: {
        en: 'Fill out at least one permit!',
        pt: 'Preencha pelo menos uma permissão!'
    },
    
    without_permission: {
        en: 'No permission to access!',
        pt: 'Sem permissão para acessar!',
    },

    filter: {
        en: "Filter",
        pt: "Filtrar"
    },

    clear: {
        en: "Clear",
        pt: "Limpar"
    },

    ai: {
        info: {
            en: 'Description to be read by AI',
            pt: 'Descrição que será lida pelo IA'
        }
    },

    soon: {
        en: 'Soon we will have information here.',
        pt: 'Em breve teremos informação aqui'
    },

    home: {
        enterprise: {
            en: "Enterprise",
            pt: "Empresarial"
        },
        journey: {
            en: "Journeys",
            pt: "Jornadas"
        },
        analytical: {
            en: 'Analytical',
            pt: 'Analítico'
        },
        core: {
            en: "Core",
            pt: "Essencial"
        },
        management: {
            en: "Management",
            pt: "Gerencial"
        },
        corporate: {
            en: "Corporate",
            pt: "Corporativo"
        }
    },

    maturity: {
        title: {
            en: 'Maturity questions',
            pt: 'Perguntas de maturidade'
        },
        active: {
            en: 'Active',
            pt: 'Ativo'
        },
        new: {
            en: 'New question',
            pt: 'Nova pergunta'
        }
    },

    attachment: {
        email: {
            en: 'E-mail',
            pt: 'E-mail'
        },
        extension: {
            en: 'Extension',
            pt: 'Extensão'
        },
        surname: {
            en: 'Nickname',
            pt: 'Apelido'
        },
        name: {
            en: 'Name',
            pt: 'Nome'
        },
        action: {
            en: 'Actions',
            pt: 'Ações'
        },
        tab: {
            en: 'Tab',
            pt: 'Aba'
        },
        type: {
            en: 'Type',
            pt: 'Tipo',

            configuration: {
                en: 'Configuration',
                pt: 'Como configurar'
            },
            solution_design: {
                en: 'Solution Design',
                pt: 'Desenho da solução'
            },
            test_plan: {
                en: 'Test Plan',
                pt: 'Plano de testes'
            },
            approval_criteria: {
                en: 'Approval Criteria',
                pt: 'Critérios de homologação'
            }
        },

    },

    delete: {
        en: 'Delete',
        pt: 'Deletar',

        title: {
            en: 'Are you sure you want to delete?',
            pt: 'Tem certeza que deseja excluir?'
        },
        confirm: {
            en: 'Confirm',
            pt: 'Confirmar'
        },
        cancel: {
            en: 'Cancel',
            pt: 'Cancelar'
        },
        persona: {
            en: "All of that personas FTE values ​​will be removed from the business tree!",
            pt: 'Todos os valores de FTE dessa persona serão removidos da árvore de negócios!'
        },
        technologies: {
            en: "Deleting technology impacts the technology tab in the business tree",
            pt: "Apagar tecnologia impacta na aba de tecnologia na árvore de negócios"
        },
        clone: {
            en: 'When deleting, all clones will be deleted',
            pt: 'Ao deletar, todos os clones serão excluídos'
        }
    },

    save: {
        en: 'Save',
        pt: 'Salvar'
    },

    saveAs: {
        en: 'Save as new version',
        pt: 'Salvar como uma nova versão'
    },

    saveChangesTree: {
        en: 'Save changes tree',
        pt: 'Salvar alterações na árvore'
    },


    createdNewVersion: {
        en: 'Create version',
        pt: 'Criar versão'
    },


    updateRow: {
        en: 'Update row',
        pt: 'Atualizar linha'
    },

    addRow: {
        en: 'Add row',
        pt: 'Adicionar linha'
    },

    edit: {
        en: 'Edit',
        pt: 'Editar'
    },



    cancel: {
        en: 'Cancel',
        pt: 'Cancelar'
    },

    create: {
        en: 'Create',
        pt: 'Criar'
    },

    name: {
        en: 'Name',
        pt: 'Nome'
    },

    link: {
        en: 'Link',
        pt: 'Link'
    },

    versions: {
        current: {
            en: 'Current',
            pt: 'Atual'
        },
        name: {
            en: 'Name',
            pt: 'Nome'
        },
        last_change: {
            en: 'Last change',
            pt: 'Última modificação'
        },
        delete: {
            en: 'Delete',
            pt: 'Deletar'
        },
        actions: {
            en: 'Actions',
            pt: 'Ações'
        },
        create: {
            name: {
                en: "Create version name",
                pt: "Criar nome para versão"
            }
        },
        edit: {
            name: {
                en: "Edit version name",
                pt: "Editar nome para versão"
            }
        },
    },

    activities: {
        user: {
            en: 'User',
            pt: 'Usuário'
        },
        profile: {
            en: 'Profile',
            pt: 'Perfil'
        },
        screen: {
            en: 'Screen',
            pt: 'Tela'
        },
        action: {
            en: 'Action',
            pt: 'Ação'
        },
        environment: {
            en: 'Environment',
            pt: 'Ambiente'
        },
        corporation: {
            en: 'Organization',
            pt: 'Organização'
        },
        principal: {
            en: 'Principal',
            pt: 'Principal'
        },
        date: {
            en: 'Date',
            pt: 'Data'
        },
        time: {
            en: 'Time',
            pt: 'Horário'
        },
        description: {
            en: 'Description',
            pt: 'Descrição'
        }
    },

    corporations: {
        en: 'Organizations',
        pt: 'Organizações',
        tree: {
            en: 'Organization tree',
            pt: 'Árvore de organizações'
        },
        info: {
            businessSolutions: {
                en: 'Business tree',
                pt: 'Árvore de negócio'
            },
            personas: {
                en: 'Organizational structure',
                pt: 'Estrutura organizacional'
            },
            dimension: {
                en: 'Dimension',
                pt: 'Dimensão'
            },
            edit: {
                en: 'Edit',
                pt: 'Editar'
            },
            newCorporation: {
                en: 'New organization',
                pt: 'Nova organização'
            },
            delete: {
                en: 'Delete',
                pt: 'Deletar'
            }
        }
    },

    auth: {
        login: {
            en: 'Login',
            pt: 'Entrar',

            email: {
                en: 'E-mail',
                pt: 'Email'
            },
            password: {
                en: 'Password',
                pt: 'Senha'
            },
            forgot: {
                en: 'Forgot password?',
                pt: 'Esqueceu a senha?'
            },
            create: {
                en: 'Create account',
                pt: 'Criar conta'
            },
        },
        forgot: {
            en: 'Forgot Password',
            pt: 'Esqueceu a senha',
            sub: {
                en: 'Enter your email address in the field below',
                pt: 'Digite seu endereço de e-mail no campo abaixo'
            },
            type: {
                en: 'Type your email',
                pt: 'Digite seu email'
            },
            send: {
                en: 'Send',
                pt: 'Enviar'
            }
        },
        create: {
            en: 'Register',
            pt: 'Cadastre-se',

            send: {
                en: 'Request registration',
                pt: 'Solicitar registro'
            },
            name: {
                en: 'Name',
                pt: 'Nome'
            },
            lastName: {
                en: 'Last Name',
                pt: 'Último Nome'
            },
            email: {
                en: 'E-mail',
                pt: 'Email'
            },
            document: {
                en: 'Document',
                pt: 'Documento'
            },
            telephone: {
                en: 'Phone',
                pt: 'Telefone'
            },
            login: {
                en: 'Have an account? ',
                pt: 'Possui uma conta? '
            }
        },
        password: {
            en: 'Update Password',
            pt: 'Alterar Senha',

            send: {
                en: 'Update',
                pt: 'Alterar',
            },
            password: {
                en: 'Password',
                pt: 'Senha',
            },
            confirm_password: {
                en: 'Confirm Password',
                pt: 'Confirmar Senha',
            },
            letters: {
                en: 'Password must contain letters',
                pt: 'Senha deve possuir letras',
            },
            numbers: {
                en: 'Password must contain numbers',
                pt: 'Senha deve possuir números',
            },
            lenght: {
                en: 'Password must contain 6 to 12 characters',
                pt: 'Senha deve ter entre 6 e 12 caracteres',
            },
            same: {
                en: 'Password must be the same',
                pt: 'Senhas devem ser iguais',
            }
        },
        alert: {
            password: {
                en: 'Incorrect mail or password',
                pt: 'Usuário ou senha incorretos'
            },
            connection: {
                en: 'Connection error',
                pt: 'Erro de conexão'
            },
            voidInput: {
                en: 'Fill in all fields *',
                pt: 'Preencha todos os campos *'
            },
            nameReservedWord: {
                en: 'This name is a reserved word',
                pt: 'Esse nome é uma palavra reservada'
            },
            acronymReservedWord: {
                en: 'This acronym is a reserved word',
                pt: 'Essa sigla é uma palavra reservada'
            },
            isEdited: {
                en: "You have changes to the tree, save before exiting",
                pt: "Você tem alterações na árvore, salve antes de sair"
            },
            closeForm: {
                en: "Do you really want to exit without saving? This means losing the changes made",
                pt: "Você realmente deseja sair sem salvar? Isso implica em perder as alterações feitas"
            },
            saveAndClose: {
                en: "Save and close",
                pt: "Salvar e sair"
            },
            closeNotSave: {
                en: "Exit without saving",
                pt: "Sair sem salvar"
            },
            choseVersion: {
                en: "Do you want to save a new version? When you save a new version, it will become the official version that will be displayed in the Business Tree",
                pt: "Deseja salvar uma nova versão? Ao salvar uma nova versão, ela se tornará a versão oficial que será exibida na Árvore de Negócios"
            },
            closeFormLink: {
                en: 'Are you sure you want to leave the link?',
                pt: 'Tem certeza que deseja sair da vinculação?'
            },
            continueLinking: {
                en: 'Continue linking',
                pt: 'Continuar vinculando'
            },
            closeLinking: {
                en: 'Exit the link',
                pt: 'Sair da vinculação'
            }
        },
    },

    slugs: {
        environment: {
            en: "Environments",
            pt: "Ambientes"
        },
        corporation: {
            en: "Organizations",
            pt: "Organizações"
        },
        profile: {
            en: "Profiles",
            pt: "Perfis"
        },
        user: {
            en: "Users",
            pt: "Usuários"
        },
        screen: {
            en: "Screens",
            pt: "Telas"
        },
        action: {
            en: "Actions",
            pt: "Ações"
        },
        date: {
            en: "Date",
            pt: "Data"
        }
    },

    errors: {
        system: {
            out: {
                en: 'System unavailable!',
                pt: 'Sistema indisponível!'
            }
        },
        businessTree: {
            create: {
                en: 'Process not created successfully',
                pt: 'Processo não criado com sucesso'
            },
            edit: {
                en: 'Process not edited successfully',
                pt: 'Processo não editado com sucesso'
            },
            delete: {
                en: 'Process not deleted successfully',
                pt: 'Processo não deletado com sucesso'
            },
            SameNameElement: {
                en: 'Sibling elements with the same name',
                pt: "Elementos irmãos com mesmo nome"
            },
            SameNameElementAncestor: {
                en: 'A user cannot be inside themselves',
                pt: "Um usuário não pode estar dentro dele mesmo"
            }
        },
        personas: {
            InvalidFteMin: {
                en: 'Invalid FTE min',
                pt: 'FTE min inválido'
            },
            PersonaWithChildren: {
                en: 'Persona with children',
                pt: 'Persona com filhos'
            },
            SameNameElement: {
                en: 'Sibling elements with the same name',
                pt: "Elementos irmãos com mesmo nome"
            },
            PersonaWithoutOrganogram: {
                en: 'Persona without organogram',
                pt: 'Persona sem organograma'
            }
        },
        noData: {
            en: 'There is no Data',
            pt: 'Não foram encontrados dados'
        },
        invalidFormatInputAttachments: {
            en: "Attachment format not allowed",
            pt: 'Formato de anexo não permitido'
        },
        attachmentsNotFound: {
            en: "Unable to download, please contact the system administrator",
            pt: 'Não foi possível realizar o download, contate o administrador do sistema'
        },
        users:{
            corporationEmpty: {
                en: 'Please select a organization!',
                pt: 'Por favor selecione uma organização!'
            },
            profileEmpty: {
                en: 'Please select a profile!',
                pt: 'Por favor selecione um perfil!'
            },
            profileStatusEmpty: {
                en: 'Please select a profile status!',
                pt: 'Por favor selecione um status de perfil!'
            }
        }
    },

    messages: {
        businessTree: {
            create: {
                en: 'Process created successfully',
                pt: 'Processo criado com sucesso',
            }
        }
    },

    profiles: {
        title: {
            en: 'Profiles',
            pt: 'Perfis'
        },
        all: {
            en: 'All',
            pt: 'Todos'
        },
        modal: {
            create: {
                en: 'Create profile',
                pt: 'Criar perfil'
            },
            edit: {
                en: 'Profile edit',
                pt: 'Editar perfil'
            },
            view: {
                en: 'Profile view',
                pt: 'Visualizar perfil'
            },
            corporateName: {
                en: 'Organization name',
                pt: 'Nome da organização'
            },
            profileName: {
                en: 'Profile name',
                pt: 'Nome do perfil'
            },
            profileType: {
                en: 'Profile type',
                pt: 'Tipo do perfil'
            },
            clone: {
                en: 'Clone profile',
                pt: 'Clonar perfil'
            },
            status: {
                en: 'Status',
                pt: 'Status'
            },
            description: {
                en: 'Description',
                pt: 'Descrição'
            },
            menu: {
                en: 'Menu',
                pt: 'Menu'
            }
        },
        modules: {
            en: 'Modules',
            pt: 'Módulos',

            operation: {
                en: 'Operation',
                pt: 'Operação'
            },
            configurations: {
                en: 'Configurations',
                pt: 'Configurações'
            },
            administrator: {
                en: 'Administrator',
                pt: 'Administrador'
            },
            services: {
                en: 'Services',
                pt: 'Serviços'
            },
        },
        screens: {
            en: 'Screens',
            pt: 'Telas',

            business_solutions: {
                en: 'Business tree',
                pt: 'Árvore de negócios'
            },
            crm_tree: {
                en: 'CRM tree',
                pt: 'Árvore de CRM'
            },
            clipboard: {
                en: 'Clipboard',
                pt: 'Área de transferência'
            },
            versioning: {
                en: 'Versioning',
                pt: 'Versionamento'
            },
            corporations: {
                en: 'Organization',
                pt: 'Organização'
            },
            organizational_structure: {
                en: 'Organizational Structure',
                pt: 'Estrutura organizacional'
            },
            standards: {
                en: 'Process Guideline',
                pt: 'Guideline de processo'
            },
            technologies: {
                en: 'Technologies',
                pt: 'Tecnologias'
            },
            maturity: {
                en: 'Maturity',
                pt: 'Maturidade'
            },
            project_guideline: {
                en: 'Project Guideline',
                pt: 'Guideline de projeto'
            },
            environments: {
                en: 'Environments',
                pt: 'Ambientes'
            },
            activities: {
                en: 'Activity Log',
                pt: 'Log de atividades'
            },
            users: {
                en: 'Users',
                pt: 'Usuários'
            },
            profiles: {
                en: 'Profiles',
                pt: 'Perfis'
            },
            code_data: {
                en: 'Code data',
                pt: 'Dados de código'
            },
            workflow: {
                en: 'Workflow',
                pt: 'Workflow'
            },
            pricing: {
                en: 'Pricing',
                pt: 'Precificação'
            },
            spreadsheets: {
                en: 'Spreadsheets',
                pt: 'Planilhas'
            },
            parameters: {
                en: 'Parameters',
                pt: 'Parâmetros'
            }

        },
        permissions: {
            en: 'Permissions',
            pt: 'Permissões',

            business_solutions: {
                view_process: {
                    en: 'View process',
                    pt: 'Visualizar processo'
                },
                create_process: {
                    en: 'Create process',
                    pt: 'Criar processo'
                },
                delete_process: {
                    en: 'Delete process',
                    pt: 'Deletar processo'
                },
                edit_process: {
                    en: 'Edit process',
                    pt: 'Editar processo'
                },
                copy_process: {
                    en: 'Copy process',
                    pt: 'Copiar processo'
                },
                clone_process: {
                    en: 'Clone process',
                    pt: 'Clonar processo'
                },
                transfer_process: {
                    en: 'Transfer process',
                    pt: 'Transferir processo'
                },
                save_tree: {
                    en: 'Save tree',
                    pt: 'Salvar árvore'
                },
                import: {
                    en: 'Import',
                    pt: 'Importar'
                },
                export: {
                    en: 'Export',
                    pt: 'Exportar'
                },
                bpmn: {
                    en: 'BPMN',
                    pt: 'BPMN'
                },
                cut_proccess: {
                    en: 'Move process',
                    pt: 'Mover processo'
                },
                copy_identifier: {
                    en: 'Copy identifier',
                    pt: 'Copiar identificador'
                },
                access_restriction: {
                    en: 'Access restriction',
                    pt: 'Restrição de acesso'
                },
                create_type_procedure: {
                    en: 'Create type procedure',
                    pt: 'Criar tipo de procedimento'
                },
                order_process: {
                    en: 'Order process',
                    pt: 'Ordenar processo'
                },
                create_type_attachment: {
                    en: 'Create type attachment',
                    pt: 'Criar tipo de anexo'
                },
                create_type_frequency: {
                    en: 'Create type frequency',
                    pt: 'Criar tipo de frequência'
                },
                create_responsible_organization: {
                    en: 'Create responsible organization',
                    pt: 'Criar organização responsável'
                }
            },
            crm_tree: {
                view_process: {
                    en: 'View process',
                    pt: 'Visualizar processo'
                },
                create_process: {
                    en: 'Create process',
                    pt: 'Criar processo'
                },
                delete_process: {
                    en: 'Delete process',
                    pt: 'Deletar processo'
                },
                edit_process: {
                    en: 'Edit process',
                    pt: 'Editar processo'
                },
                copy_process: {
                    en: 'Copy process',
                    pt: 'Copiar processo'
                },
                clone_process: {
                    en: 'Clone process',
                    pt: 'Clonar processo'
                },
                save_tree: {
                    en: 'Save tree',
                    pt: 'Salvar árvore'
                },
                import: {
                    en: 'Import',
                    pt: 'Importar'
                },
                export: {
                    en: 'Export',
                    pt: 'Exportar'
                },
                cut_proccess: {
                    en: 'Move process',
                    pt: 'Mover processo'
                },
                access_restriction: {
                    en: 'Access restriction',
                    pt: 'Restrição de acesso'
                },
                order_process: {
                    en: 'Order process',
                    pt: 'Ordenar processo'
                },
                create_type_attachment: {
                    en: 'Create type attachment',
                    pt: 'Criar tipo de anexo'
                },
                transfer_process: {
                    en: 'Transfer process',
                    pt: 'Transferir processo'
                },
                create_responsible_organization: {
                    en: 'Create responsible organization',
                    pt: 'Criar organização responsável'
                }
            },
            clipboard: {
                link: {
                    en: 'Link',
                    pt: 'Vincular'
                }
            },
            versioning: {
                change_version: {
                    en: 'Change version',
                    pt: 'Trocar versão'
                },
                edit: {
                    en: 'Edit',
                    pt: 'Editar'
                },
                delete: {
                    en: 'Delete',
                    pt: 'Deletar'
                }
            },
            corporations: {
                create: {
                    en: 'Create',
                    pt: 'Criar'
                },
                edit: {
                    en: 'Edit',
                    pt: 'Editar'
                },
                delete: {
                    en: 'Delete',
                    pt: 'Deletar'
                },
                dimension: {
                    en: 'Dimension',
                    pt: 'Dimensão'
                },
                business_tree: {
                    en: 'Business tree',
                    pt: 'Árvore de negócios'
                },
                organizational_structure: {
                    en: 'Organizational structure',
                    pt: 'Estrutura organizacional'
                },
                create_segment: {
                    en: 'Create segment',
                    pt: 'Criar segmento'
                },
                create_type: {
                    en: 'Create type',
                    pt: 'Criar tipo'
                }
            },
            organizational_structure: {
                save_structure: {
                    en: 'Save structure',
                    pt: 'Salvar estrutura'
                },
                create_skills: {
                    en: 'Create skills',
                    pt: 'Criar competências'
                },
                create_variations: {
                    en: 'Create variations',
                    pt: 'Criar Variações'
                },
                create_specialties: {
                    en: 'Create specialties',
                    pt: 'Criar especialidades'
                },
                remove_specialties: {
                    en: 'Remove specialties',
                    pt: 'Remover especialidades'
                },
                create: {
                    en: 'Create',
                    pt: 'Criar'
                },
                edit: {
                    en: 'Edit',
                    pt: 'Editar'
                },
                delete: {
                    en: 'Delete',
                    pt: 'Deletar'
                },
                import: {
                    en: 'Import',
                    pt: 'Importar'
                },
                export: {
                    en: 'Export',
                    pt: 'Exportar'
                },
                view: {
                    en: 'View',
                    pt: 'Visualizar'
                },
                remove_skills: {
                    en: 'Remove skills',
                    pt: 'Remover competências'
                },
                choose_reference_personas: {
                    en: 'Choose reference',
                    pt: 'Escolher referência'
                }
            },
            standards: {
                parametrize_level: {
                    en: 'Parametrize level',
                    pt: 'Parametrizar nível'
                },
                import_guideline: {
                    en: 'Import guideline',
                    pt: 'Importar guideline'
                },
                edit_level: {
                    en: 'Edit level',
                    pt: 'Editar nível'
                }
            },
            project_guideline: {
                create: {
                    en: 'Create',
                    pt: 'Criar'
                },
                edit: {
                    en: 'Edit',
                    pt: 'Editar'
                },
                delete: {
                    en: 'Delete',
                    pt: 'Deletar'
                },
                save_structure: {
                    en: 'Save structure',
                    pt: 'Salvar estrutura'
                },
                export: {
                    en: 'Export',
                    pt: 'Exportar'
                },
                view: {
                    en: 'View',
                    pt: 'Visualizar'
                },
                create_type: {
                    en: 'Create type',
                    pt: 'Criar tipo'
                }                
            },
            technologies: {
                create: {
                    en: 'Create',
                    pt: 'Criar'
                },
                edit: {
                    en: 'Edit',
                    pt: 'Editar'
                },
                delete: {
                    en: 'Delete',
                    pt: 'Deletar'
                },
                set_nature: {
                    en: 'Set nature',
                    pt: 'Definir natureza'
                },
                view: {
                    en: 'View',
                    pt: 'Visualizar'
                },
                save_structure: {
                    en: 'Save structure',
                    pt: 'Salvar estrutura'
                },
                import: {
                    en: 'Import',
                    pt: 'Importar'
                },
                export: {
                    en: 'Export',
                    pt: 'Exportar'
                },
                delete_nature: {
                    en: 'Delete landscape',
                    pt: 'Deletar natureza de tecnologia'
                }               
            },
            maturity: {
                create: {
                    en: 'Create',
                    pt: 'Criar'
                },
                edit: {
                    en: 'Edit',
                    pt: 'Editar'
                },
                save_list: {
                    en: 'Save list',
                    pt: 'Salvar lista'
                }
            },
            users: {
                create_user: {
                    en: 'Create user',
                    pt: 'Criar usuário'
                },
                delete_user: {
                    en: 'Delete user',
                    pt: 'Deletar usuário'
                },
                edit_access: {
                    en: 'Edit access',
                    pt: 'Editar acesso'
                },
                view_user: {
                    en: 'View user',
                    pt: 'Visualizar usuário'
                },
                choose_approval: {
                    en: 'Choose approver',
                    pt: 'Escolher aprovador'
                }                
            },
            environments: {
                create: {
                    en: 'Create',
                    pt: 'Criar'
                },
                edit: {
                    en: 'Edit',
                    pt: 'Editar'
                },
                delete: {
                    en: 'Delete',
                    pt: 'Deletar'
                },
                create_user: {
                    en: 'Create user',
                    pt: 'Criar usuário'
                },
                link_user: {
                    en: 'Link user',
                    pt: 'Vincular usuário'
                }
            },
            activities: {
                view: {
                    en: 'View',
                    pt: 'Visualizar'
                }
            },
            profiles: {
                create_profile: {
                    en: 'Create profile',
                    pt: 'Criar perfil'
                },
                edit_profile: {
                    en: 'Edit profile',
                    pt: 'Editar perfil'
                },
                delete_profile: {
                    en: 'Delete profile',
                    pt: 'Deletar perfil'
                }
            },
            code_data: {
                create_code_data: {
                    en: 'Create code data',
                    pt: 'Criar dados de código'
                },
                edit_code_data: {
                    en: 'Edit code data',
                    pt: 'Editar dados de código'
                },
                delete_code_data: {
                    en: 'Delete code data',
                    pt: 'Deletar dados de código'
                }
            },
            workflow: {
                create: {
                    en: 'Create',
                    pt: 'Criar'
                },
                delete: {
                    en: 'Delete',
                    pt: 'Deletar'
                },
                save_tree: {
                    en: 'Save tree',
                    pt: 'Salvar árvore'
                },
                import: {
                    en: 'Import',
                    pt: 'Importar'
                },
                export: {
                    en: 'Export',
                    pt: 'Exportar'
                },
                choose_reference_personas: {
                    en: 'Choose reference',
                    pt: 'Escolher referência'
                },
                choose_availability: {
                    en: 'Choose availability',
                    pt: 'Escolher disponibilidade'
                }
            },
            pricing: {
                create_sheet: {
                    en: 'Create spreadsheet',
                    pt: 'Criar planilha'
                },
                edit_sheet: {
                    en: 'Edit spreadsheet',
                    pt: 'Editar planilha'
                },
                sheet_control: {
                    en: 'Spreadsheet control',
                    pt: 'Controle de planilhas'
                }
            },
            spreadsheets: {
                sheet_control: {
                    en: 'Spreadsheet control',
                    pt: 'Controle de planilhas'
                }
            },
            parameters: {
                parameters_control: {
                    en: 'Parameters control',
                    pt: 'Controle de parâmetros'
                },
                history: {
                    en: 'History',
                    pt: 'Histórico'
                }
            }
        }
    },


    code_data: {
        title: {
            en: 'Code data',
            pt: 'Dados de código'
        },
        select_type: {
            en: "Select the code data",
            pt: "Selecione o dado de código"
        },
        newPlus: {
            en: 'It is not possible to save lines with the name "New +"',
            pt: 'Não é possível salvar linhas com o nome "New +"',
        },
        success: {
            en: 'Information updated successfully!',
            pt: 'Informações atualizadas com sucesso!',
        },
        attibute_type: {
            en: 'Attribute type',
            pt: 'Tipo de atributo'
        },
        values: {
            en: 'Values',
            pt: 'Valores'
        }   
    },

    import: {
        title: {
            en: 'Import .xls or .xlsx',
            pt: 'Importar .xls ou .xlsx'
        },
        push: {
            en: 'Push',
            pt: 'Enviar'
        },
        model: {
            en: 'Download template',
            pt: 'Download template'
        },
        text: {
            en: 'Select the file to import',
            pt: 'Selecione o arquivo para importar'
        }

    },

    instances: {
        title: {
            en: 'Environments',
            pt: 'Ambientes'
        },
        content: {
            table: {
                name: {
                    en: 'Name',
                    pt: 'Nome',
                },
                status: {
                    en: 'Status',
                    pt: 'Status',
                },
                acronym: {
                    en: 'Acronyn',
                    pt: 'Sigla',
                },
                activateOn: {
                    en: 'Activate On',
                    pt: 'Ativo Em',
                }
            },
            image: {
                en: 'Image',
                pt: 'Imagem'
            },
            upload_image: {
                en: 'Upload image',
                pt: 'Upload de imagem'
            }
        },
        modal: {
            create: {
                title: {
                    en: 'Create Instance',
                    pt: 'Criar Instância'
                }
            },
            edit: {
                title: {
                    en: 'Edit Instance',
                    pt: 'Editar Instância'
                },
                remove: {
                    en: 'Delete Instance',
                    pt: 'Apagar Instância'
                }
            },
            user: {
                title: {
                    en: 'Association Users to Environments',
                    pt: 'Associação de Usuários com Ambientes'
                },
                instances: {
                    en: 'Environments',
                    pt: 'Ambientes'
                },
                register: {
                    en: 'Register',
                    pt: 'Registrar'
                },
                newUser: {
                    en: 'New user',
                    pt: 'Novo usuário'
                },
                linkUsers: {
                    en: 'Link users',
                    pt: 'Vincular usuários'
                },
                selectUsers: {
                    en: 'Select users',
                    pt: 'Selecionar usuários'
                },
                linkProfiles: {
                    en: 'Link profiles',
                    pt: 'Vincular perfis'
                },
                nameInstance: {
                    en: 'Name Environments',
                    pt: 'Nome dos Ambientes'
                },
                search: {
                    en: 'Search',
                    pt: 'Pesquisar'
                },
                id: {
                    en: 'ID',
                    pt: 'ID'
                },
                name: {
                    en: 'Name',
                    pt: 'Nome'
                },
                profile: {
                    en: 'Profile',
                    pt: 'Perfil'
                },
                corporation: {
                    en: 'Organization',
                    pt: 'Organização'
                },
                telephone: {
                    en: 'Phone',
                    pt: 'Telefone'
                },
                email: {
                    en: 'Email',
                    pt: 'E-mail'
                },
                access: {
                    en: 'Access',
                    pt: 'Acesso'
                },
                viewUser: {
                    title: {
                        en: 'User',
                        pt: 'Usuário'
                    },
                    name: {
                        en: 'Name',
                        pt: 'Nome'
                    },
                    phone: {
                        en: 'Phone',
                        pt: 'Telefone'
                    },
                    email: {
                        en: 'Email',
                        pt: 'E-mail'
                    },
                    instances: {
                        en: 'Environments',
                        pt: 'Ambientes'
                    }
                }
            }
        },
    },

    pages: {
        menu: {
            dashboard: {
                en: 'Dashboard',
                pt: 'Painel'
            },
            businessSolution: {
                en: 'Business tree',
                pt: 'Árvore de negócio'
            },
            foundation: {
                en: 'Foundation',
                pt: 'Instituição',
            },
            corporation: {
                en: 'Organization',
                pt: 'Organização'
            },
            users: {
                en: 'Users',
                pt: 'Usuários'
            },
            profile: {
                en: 'Profiles',
                pt: 'Perfis'
            },
            adm: {
                en: 'Administrator',
                pt: 'Administrador'
            },
            services: {
                en: 'Services',
                pt: 'Serviços'
            },
            instances: {
                en: 'Environments',
                pt: 'Ambientes'
            },
            standards: {
                en: "Process guideline",
                pt: "Guideline de processo"
            },
            personas: {
                en: 'Organizational structure',
                pt: 'Estrutura organizacional',
                es: 'Personas',
            },
            technologies: {
                en: 'Technologies',
                pt: 'Tecnologias',
                es: 'Tecnologias',
            }
        },
        modules: {
            home: {
                en: 'Home',
                pt: 'Página inicial',
            },
            administrator: {
                en: 'Administrator',
                pt: 'Administrador',
            },
            services: {
                en: 'Services',
                pt: 'Serviços'
            },
            register: {
                en: 'Register',
                pt: 'Registro',
            },
            settings: {
                en: 'Settings',
                pt: 'Configurações',
            },
            operation: {
                en: 'Operation',
                pt: 'Operação',
            }
        },
        screens: {
            services: {
                pricing: {
                    en: 'Pricing',
                    pt: 'Precificação'
                }
            },
            administrator: {
                environments: {
                    en: 'Environment',
                    pt: 'Ambiente'
                },
                activities: {
                    en: 'Activity log',
                    pt: 'Log de atividades'
                },
                versioning: {
                    en: 'Versioning',
                    pt: 'Versionamento'
                },
                clipboard: {
                    en: 'Clipboard',
                    pt: 'Área de transferência'
                },
            },
            register: {
                corporations: {
                    en: 'Organization',
                    pt: 'Organização'
                },
                profiles: {
                    en: 'Profile',
                    pt: 'Perfis'
                },
                users: {
                    en: 'Users',
                    pt: 'Usuários'
                },
            },
            operation: {
                business_solutions: {
                    en: 'Business tree',
                    pt: 'Árvore de negócio'
                },
            },
            settings: {
                maturity: {
                    en: 'Maturity',
                    pt: 'Maturidade'
                },
                standards: {
                    en: "Process guideline",
                    pt: "Guideline de processo"
                }
            },
            home: {
                home: {
                    en: 'Home',
                    pt: 'Página inicial',
                },
            }
        },
        info: {
            language: {
                en: 'Choose Language',
                pt: 'Trocar Idioma'
            },
            instance: {
                en: 'Choose Instance',
                pt: 'Trocar Ambiente'
            },
            user: {
                en: 'User Config',
                pt: 'Configurações de Usuário'
            },
            config: {
                en: 'System Config',
                pt: 'Configurações do Sistema'
            }
        }
    },

    configurations: {
        title: {
            en: 'User settings',
            pt: 'Configurações de usuário'
        },
        general: {
            en: "General Settings",
            pt: "Configurações gerais"
        },
        language: {
            en: "Language",
            pt: "Idioma"
        },
        corporation: {
            en: "Favorite organization",
            pt: "Organização favorita"
        },
        environment: {
            en: "Environment",
            pt: "Ambiente"
        }
    },

    workflow: {
        top: {
            title: {
                en: 'Workflow',
                pt: 'Workflow'
            },
            totalNumber: {
                en: 'Total number',
                pt: 'Número total'
            }
        },
        content: {
            workflowTree: {
                en: 'Workflow tree',
                pt: 'Árvore de workflow'
            }
        },
        choose_reference: {
            en: 'Change reference',
            pt: 'Trocar referência',

            confirm: {
                en: 'Do you want to change the reference of the workflow?',
                pt: 'Deseja alterar a referência do workflow?'
            },
        }
    },

    crmTree: {
        en: 'CRM',
        pt: 'CRM',

        content: {
            title: {
                en: 'CRM tree',
                pt: 'Árvore de CRM'
            }
        }
    },

    businessSolution: {
        version: {
            name: {
                en: "Version name",
                pt: "Nome da versão"
            }
        },
        search: {
            of: {
                en: 'of',
                pt: 'de'
            },
            noResult: {
                en: 'Your search returned no results',
                pt: 'Sua pesquisa não retornou resultados'
            }
        },
        top: {
            settings: {
                en: 'Settings',
                pt: 'Configurações'
            },
            indicators: {
                en: "Indicators",
                pt: "Indicadores"
            },
            journeys: {
                en: "Journeys",
                pt: "Jornadas"
            },
            copy: {
                success: {
                    en: 'Text successfully copied to clipboard!',
                    pt: 'Texto copiado para a área de transferência com sucesso!'
                },
                warning: {
                    en: 'Unable to copy the text. Please try again.',
                    pt: 'Não foi possível copiar o texto. Por favor, tente novamente.'
                },
                danger: {
                    en: 'Unexpected error occurred.',
                    pt: 'Erro inesperado.'
                }
            },
            info: {
                corporation: {
                    en: 'Filter organization',
                    pt: 'Filtrar organização'
                },
                dimension: {
                    en: 'Filter dimension',
                    pt: 'Filtrar dimensão'
                },
                export: {
                    en: 'Export',
                    pt: 'Exportar',

                    xls: {
                        en: 'Export xls',
                        pt: 'Exportar xls'
                    },
                    json: {
                        en: 'Export JSON',
                        pt: 'Exportar JSON'
                    },
                    success: {
                        en: 'Successfully exported',
                        pt: 'Exportado com sucesso'
                    }
                },
                totalNumberProcess: {
                    en: "Total number of process",
                    pt: "Número total de processos"
                },
                import: {
                    en: 'Import',
                    pt: 'Importar'
                },
                finished: {
                    en: 'Finished',
                    pt: 'Concluir'
                },
                copy: {
                    en: 'Copy',
                    pt: 'Copiar'
                },
                cut: {
                    en: 'Cut',
                    pt: 'Cortar'
                },
                goToOriginNode: {
                    en: 'Go to source node',
                    pt: 'Ir para nó de origem'
                },
                clone: {
                    en: 'Clone',
                    pt: 'Clonar'
                },
                add: {
                    en: 'New process',
                    pt: 'Novo processo'
                },
                cloned: {
                    en: 'Clone',
                    pt: 'Clone'
                },
                is_cloned: {
                    en: 'Cloned',
                    pt: 'Clonado',

                    info: {
                        en: 'All changes will be replicated to your clones',
                        pt: 'Todas as alterações serão replicadas em seus clones'
                    }
                },
                paste: {
                    en: 'Paste',
                    pt: 'Colar'
                },
                loading: {
                    en: 'Load data',
                    pt: 'Carregar dados'
                },
                template: {
                    en: 'Import template',
                    pt: 'Importar template'
                },
                copy_to_clipboard: {
                    en: "Copy to clipboard",
                    pt: "Copiar para área de transferência"
                },
                delete_process: {
                    en: "Delete process",
                    pt: "Deletar processo"
                },
                diagram: {
                    en: "Diagram",
                    pt: "Diagrama"
                },
                sort_children: {
                  en: 'Sort Children Alphabetically',
                  pt: 'Ordenar Filhos Alfabeticamente',
                  es: 'Ordenar Hijos Alfabéticamente'
                }
            }
        },
        content: {
            processTree: {
                en: 'Process tree',
                pt: 'Árvore de processos'
            },
            top: {
                en: 'Business tree',
                pt: 'Árvore de negócio'
            },

            info: {
                expand: {
                    en: 'Expand tree',
                    pt: 'Expandir árvore'
                },
                collapse: {
                    en: 'Collapse tree',
                    pt: 'Recolher árvore'
                },
                create: {
                    en: 'Create process',
                    pt: 'Criar processo'
                },
                guideline: {
                    en: 'Configure process guideline to create your business tree',
                    pt: 'Configure o guideline de processo para criar sua árvore de negócio'
                },
                goToGuideline: {
                    en: "Go to process guideline",
                    pt: "Ir para guideline de processo"
                },
                goToTechnologies: {
                    en: "Go to Technologies",
                    pt: "Ir para Tecnologias"
                }
            }
        },
        modal: {
            upload: {
                title: {
                    en: 'Import data',
                    pt: 'Importar dados'
                },
                select: {
                    en: 'Select document',
                    pt: 'Selecionar documento'
                },
                push: {
                    en: 'Push',
                    pt: 'Enviar'
                }
            },
            delete: {
                title: {
                    en: 'Attention!',
                    pt: 'Atenção!'
                },
                content: {
                    en: 'Do you really want to delete the component?',
                    pt: 'Você realmente deseja excluir o componente?'
                },
                cancel: {
                    en: 'Cancel',
                    pt: 'Cancelar'
                },
                confirm: {
                    en: 'Confirm',
                    pt: 'Confirmar'
                }
            },
            create: {
                title: {
                    en: 'Create',
                    pt: 'Criar'
                }
            },
            edit: {
                title: {
                    en: 'Edit',
                    pt: 'Editar'
                }
            },
            view: {
                title: {
                    en: 'view',
                    pt: 'Visualizar'
                }
            },
            addCode: {
                title: {
                    en: 'Description',
                    pt: 'Descrição'
                },
                created_at: {
                    en: 'Inclusion date',
                    pt: 'Data inclusão'
                },
                userCreated: {
                    en: "Included by",
                    pt: "Incluído por"
                },
                updated_at: {
                    en: 'Last update date',
                    pt: 'Data última atualização'
                },
                userUpdated: {
                    en: 'Last updated by',
                    pt: 'Última atualização por'
                },
                organogram_responsible: {
                    en: 'Responsible organogram',
                    pt: 'Área responsável'
                },
                organogram_executing: {
                    en: 'Executing organogram',
                    pt: 'Área executora'
                },
                business: {
                    en: 'Business',
                    pt: 'Empresa'
                },
                reference: {
                    en: 'Reference',
                    pt: 'Referencia'
                },
                code: {
                    en: 'Code',
                    pt: 'Código'
                },
                process: {
                    en: 'Process Name',
                    pt: 'Nome do Processo'
                },
                id: {
                    en: 'ID',
                    pt: 'ID'
                },
                rules: {
                    en: 'Procedures',
                    pt: 'Procedimentos'
                },
                extendedAttributes: {
                    en: 'Extended Atributes',
                    pt: 'Atributos Extendidos'
                },
                copyLink: {
                    en: 'Copy identifier',
                    pt: "Copiar identificador"
                },
                links: {
                    en: 'Links',
                    pt: 'Links'
                },
                ruleType: {
                    en: 'Rule Type',
                    pt: 'Tipo de Regra'
                },
                name: {
                    en: 'Name',
                    pt: 'Nome'
                },
                status: {
                    en: 'Status',
                    pt: 'Status'
                },
                actions: {
                    en: 'Actions',
                    pt: 'Ações'
                },
                scenario: {
                    en: 'Scenario',
                    pt: 'Cenário'
                },
                behavior: {
                    en: 'Behavior',
                    pt: 'Comportamento'
                },
                client: {
                    en: 'Client',
                    pt: 'Cliente'
                },
                type: {
                    en: 'Tipo',
                    pt: 'Type'
                },
                configurations: {
                    en: 'Configurations',
                    pt: 'Configurações'
                },
                integrations: {
                    en: 'Integrations',
                    pt: 'Integrações'
                },
                indicators: {
                    en: 'Analytical',
                    pt: 'Analítico'
                },
                attachments: {
                    en: 'New attachment',
                    pt: 'Novo anexo'
                },
                rulesDrawing: {
                    en: 'Rules Drawing',
                    pt: 'Desenho de Regras'
                },
                importance: {
                    en: "Relevance",
                    pt: "Relevância"
                },
                frequency: {
                    en: "Frequency",
                    pt: "Frequência"
                },
                fte: {
                    en: "FTE",
                    pt: "FTE"
                },
                fte_cost: {
                    en: "FTE cost",
                    pt: "Custo FTE"
                },
                sla: {
                    en: "SLA",
                    pt: "SLA"
                },
                sla_unit: {
                    en: "SLA unit",
                    pt: "Unidade de SLA"
                },
                description: {
                    en: "Description",
                    pt: "Descrição"
                },
                link: {
                    en: "External link",
                    pt: "Link externo"
                },
                strategy: {
                    en: "Strategic objectives",
                    pt: "Objetivos estratégicos"
                },
                classification: {
                    en: "Breed",
                    pt: "Classe"
                },
                processOwner: {
                    en: "User creation",
                    pt: "Usuário criação"
                },
                rpa_percentage: {
                    en: "RPA",
                    pt: "RPA",
                    info: {
                        en: "100%: Fully robotizable, 50%: Partially robotizable, 0%: Not robotizable",
                        pt: "100%: Totalmente robotizável, 50%: Parcialmente robotizável, 0%: Não robotizável"
                    }
                },
                icon: {
                    en: "Icon",
                    pt: "Ícone"
                },
                active_crm: {
                    en: "Active CRM",
                    pt: "Ativar CRM"
                },
                inactive_crm: {
                    en: "Inactive CRM",
                    pt: "Desativar CRM"
                }
            },

            strategicPlanning: {
                title: {
                    en: 'Strategic planning',
                    pt: 'Planejamento estratégico'
                },
                organization: {
                    en: 'Organization',
                    pt: 'Organização'
                },
                name: {
                    en: 'Name',
                    pt: 'Nome'
                },
                action: {
                    en: 'Action',
                    pt: 'Ação'
                },
                result: {
                    en: 'Result',
                    pt: 'Resultado'
                },
                date: {
                    en: 'Date',
                    pt: 'Data'
                }
            },

            contacts: {
                title: {
                    en: 'Contacts',
                    pt: 'Contatos'
                },
                name: {
                    en: 'Name',
                    pt: 'Nome'
                },
                email: {
                    en: 'Email',
                    pt: 'E-mail'
                },
                phone: {
                    en: 'Phone',
                    pt: 'Telefone'
                },
                area: {
                    en: 'Areas',
                    pt: 'Áreas'
                },
                function: {
                    en: 'Function',
                    pt: 'Função'
                },
                type: {
                    en: 'Type',
                    pt: 'Tipo'
                },
                new_contact: {
                    en: 'New contact',
                    pt: 'Novo contato'
                },
                save_contact: {
                    en: 'Save contact',
                    pt: 'Salvar contato'
                },
                errors: {
                    typeContact: {
                        en: "Contact type already registered",
                        pt: "Tipo de contato já cadastrado"
                    }
                },

            },
            phase: {
                title: {
                    en: 'Phase',
                    pt: 'Estágios'
                },
                percentage: {
                    en: 'Percentage',
                    pt: 'Porcentagem'
                },
                observation: {
                    en: 'Observation',
                    pt: 'Observação'
                },
                week: {
                    en: 'Week',
                    pt: 'Semana'
                },
                phase: {
                    en: 'Phase',
                    pt: 'Estágio'
                },
                date: {
                    en: 'Date',
                    pt: 'Data'
                },
                action: {
                    en: 'Action',
                    pt: 'Ação'
                },
                nameOportunity: {
                    en: 'Name Oportunity',
                    pt: 'Nome Oportunidade'
                },
                entryDate: {
                    en: 'Entry date',
                    pt: 'Data de entrada'
                },
                weeks: {
                    en: 'Weeks',
                    pt: 'Semanas'
                },
                organizationResponsible: {
                    en: 'Organization responsible',
                    pt: 'Organização responsável'
                },
                addWeek: {
                    en: 'Add week',
                    pt: 'Adicionar semana'
                }

            },      
            fte: {
                title: {
                    en: 'FTE',
                    pt: 'FTE'
                },
                start_date: {
                    en: 'Date start',
                    pt: 'Data de início'
                },
                end_date: {
                    en: 'Date end',
                    pt: 'Data de término'
                },
                arbitrary_value: {
                    en: 'Arbitrary value',
                    pt: 'Valor arbitrado'
                },
                real_value: {
                    en: 'Real value',
                    pt: 'Valor real'
                },
                yes: {  
                    en: 'Yes',
                    pt: 'Sim'
                },
                no: {
                    en: 'No',
                    pt: 'Não'
                },
                isSap: {
                    en: 'Is SAP',
                    pt: 'É SAP'
                },
                addMonth: {
                    en: 'Add month',
                    pt: 'Adicionar mês'
                },
                month: {        
                    en: 'Month',
                    pt: 'Mês'
                },
                fte: {
                    en: 'FTE',
                    pt: 'FTE'
                },
                sumFte: {
                    en: 'Sum FTE',
                    pt: 'Soma FTE'
                }
            },

            skills: {
                title: {
                    en: 'Skills',
                    pt: 'Competências'
                },
                addRow: {
                    en: "Add row",
                    pt: "Adicionar linha"
                },
                search: {
                    en: "Search skills",
                    pt: "Buscar competências"
                }
            },
            strategy: {
                title: {
                    en: 'Strategy',
                    pt: 'Estratégia'
                },
                business: {
                    en: 'Business',
                    pt: 'Empresa'
                },
                name: {
                    en: 'Name',
                    pt: 'Nome'
                },
                process: {
                    en: 'Process',
                    pt: 'Processo'
                },
                scope: {
                    en: 'Scope',
                    pt: 'Escopo'
                },
                description: {
                    en: 'Description',
                    pt: 'Descrição'
                },
                itensPage: {
                    en: 'Items',
                    pt: 'Itens'
                },
                totalPages: {
                    en: 'Total',
                    pt: 'Total'
                },
                info: {
                    scope: {
                        en: 'It refers to the set of goals, objectives, activities, and deliverables that are defined and documented at the beginning of a project.',
                        pt: 'Isso se refere ao conjunto de metas, objetivos, atividades e entregas que são definidos e documentados no início de um projeto.'
                    },
                    newColumn: {
                        en: 'Add Column',
                        pt: 'Adicionar Coluna'
                    },
                    newRow: {
                        en: 'Add Row',
                        pt: 'Adicionar Linha'
                    },
                    removeColumn: {
                        en: 'Remove Column',
                        pt: 'Remover Coluna'
                    },
                    removeRow: {
                        en: 'Remove Rows',
                        pt: 'Remover Linhas'
                    }
                }
            },
            organogram: {
                title: {
                    en: 'Organogram',
                    pt: 'Organograma'
                },
                business: {
                    en: 'Business',
                    pt: 'Empresa'
                },
                name: {
                    en: 'Name',
                    pt: 'Nome'
                },
                process: {
                    en: 'Process',
                    pt: 'Processo'
                },
                scope: {
                    en: 'Scope',
                    pt: 'Escopo'
                },
                description: {
                    en: 'Description',
                    pt: 'Descrição'
                },
                info: {
                    scope: {
                        en: 'It refers to the set of goals, objectives, activities, and deliverables that are defined and documented at the beginning of a project.',
                        pt: 'Isso se refere ao conjunto de metas, objetivos, atividades e entregas que são definidos e documentados no início de um projeto.'
                    }
                }
            },
            people: {
                title: {
                    en: 'Organizational structure',
                    pt: 'Estrutura organizacional',
                },
                business: {
                    en: 'Business',
                    pt: 'Empresa'
                },
                name: {
                    en: 'Name',
                    pt: 'Nome'
                },
                process: {
                    en: 'Process',
                    pt: 'Processo'
                },
                scope: {
                    en: 'Scope',
                    pt: 'Escopo'
                },
                description: {
                    en: 'Description',
                    pt: 'Descrição'
                },
                positions: {
                    en: 'Positions and Functions',
                    pt: 'Posições e Funções'
                },
                fte: {
                    en: 'FTE',
                    pt: 'FTE'
                },
                organization: {
                    en: 'Organization Chart',
                    pt: 'Organograma Chart'
                },
                frequency: {
                    en: 'Frequency',
                    pt: 'Frequência'
                },
                sla: {
                    en: 'SLA',
                    pt: 'SLA'
                },
                slaUnity: {
                    en: 'SLA Unity',
                    pt: 'Unidade de SLA'
                },
                info: {
                    scope: {
                        en: 'It refers to the set of goals, objectives, activities, and deliverables that are defined and documented at the beginning of a project.',
                        pt: 'Isso se refere ao conjunto de metas, objetivos, atividades e entregas que são definidos e documentados no início de um projeto.'
                    },
                    positions: {
                        en: 'Positions and functions is related to the responsibilities, tasks, and roles performed by individuals within an organization.',
                        pt: 'Posições e funções estão relacionadas às responsabilidades, tarefas e papéis desempenhados por indivíduos dentro de uma organização.'
                    },
                    fte: {
                        en: 'In business solution, FTE (Full-Time Equivalent) is a measure used to determine the workload or size of a team required to carry out specific activities or processes.',
                        pt: 'Em soluções empresariais, FTE (Equivalente a Tempo Integral) é uma medida usada para determinar a carga de trabalho ou o tamanho de uma equipe necessária para realizar atividades ou processos específicos.'
                    },
                    organization: {
                        en: 'It refers to a graphical and structural representation of the hierarchy and relationships between departments, positions, and functions within an organization.',
                        pt: 'Isso se refere a uma representação gráfica e estrutural da hierarquia e das relações entre departamentos, cargos e funções dentro de uma organização.'
                    },
                    frequency: {
                        en: 'In business solution, the concept of frequency refers to how often certain activities or events occur within a given period of time.',
                        pt: 'Em soluções empresariais, o conceito de frequência se refere a com que frequência certas atividades ou eventos ocorrem dentro de um determinado período de tempo.'
                    },
                    sla: {
                        en: 'In business management, a Service Level Agreement (SLA) Unit refers to a time metric used to establish commitments and performance standards regarding the services provided by an organization.',
                        pt: 'Na gestão empresarial, uma Unidade de Acordo de Nível de Serviço (SLA) refere-se a uma métrica de tempo usada para estabelecer compromissos e padrões de desempenho relacionados aos serviços prestados por uma organização.'
                    },
                    slaUnity: {
                        en: 'In business management, an SLA (Service Level Agreement) Unit refers to a time metric used to establish commitments and performance standards regarding the services provided by an organization.',
                        pt: 'Na gestão empresarial, uma Unidade de SLA (Acordo de Nível de Serviço) refere-se a uma métrica de tempo usada para estabelecer compromissos e padrões de desempenho relacionados aos serviços prestados por uma organização.'
                    },
                    newColumn: {
                        en: 'Add Column',
                        pt: 'Adicionar Coluna'
                    },
                    newRow: {
                        en: 'Add Row',
                        pt: 'Adicionar Linha'
                    },
                    removeColumn: {
                        en: 'Remove Column',
                        pt: 'Remover Coluna'
                    },
                    removeRow: {
                        en: 'Remove Rows',
                        pt: 'Remover Linhas'
                    }
                },
                itensPage: {
                    en: 'Items',
                    pt: 'Itens'
                },
                totalPages: {
                    en: 'Total',
                    pt: 'Total'
                },

            },
            technology: {
                title: {
                    en: 'Technology',
                    pt: 'Tecnologia'
                },
                business: {
                    en: 'Business',
                    pt: 'Empresa'
                },
                name: {
                    en: 'Name',
                    pt: 'Nome'
                },
                process: {
                    en: 'Process',
                    pt: 'Processo'
                },
                scope: {
                    en: 'Scope',
                    pt: 'Escopo'
                },
                description: {
                    en: 'Description',
                    pt: 'Descrição'
                },
                corporation: {
                    en: 'Organization Chart',
                    pt: 'Organograma Chart'
                },
                slaPlatform: {
                    en: 'SLA Platform',
                    pt: 'Plataforma de SLA'
                },
                app: {
                    en: 'App Name',
                    pt: 'Nome do aplicativo '
                },
                externalLink: {
                    en: 'External Link',
                    pt: 'Link Externo'
                },
                info: {
                    sla: {
                        en: 'The concept of an SLA (Service Level Agreement) platform in business solutions refers to a software or technology solution that helps organizations manage and monitor their SLAs with customers or service providers.',
                        pt: 'O conceito de uma plataforma de SLA (Acordo de Nível de Serviço) em soluções empresariais se refere a uma solução de software ou tecnologia que ajuda as organizações a gerenciar e monitorar seus SLAs com clientes ou provedores de serviços.'
                    },
                    organization: {
                        en: 'It refers to a graphical and structural representation of the hierarchy and relationships between departments, positions, and functions within an organization.',
                        pt: 'Isso se refere a uma representação gráfica e estrutural da hierarquia e das relações entre departamentos, cargos e funções dentro de uma organização.'
                    },
                    scope: {
                        en: 'It refers to the set of goals, objectives, activities, and deliverables that are defined and documented at the beginning of a project.',
                        pt: 'Isso se refere ao conjunto de metas, objetivos, atividades e entregas que são definidos e documentados no início de um projeto.'
                    },
                    newColumn: {
                        en: 'Add Column',
                        pt: 'Adicionar Coluna'
                    },
                    newRow: {
                        en: 'Add Row',
                        pt: 'Adicionar Linha'
                    },
                    removeColumn: {
                        en: 'Remove Column',
                        pt: 'Remover Coluna'
                    },
                    removeRow: {
                        en: 'Remove Rows',
                        pt: 'Remover Linhas'
                    }
                },
                itensPage: {
                    en: 'Items',
                    pt: 'Itens'
                },
                totalPages: {
                    en: 'Total',
                    pt: 'Total'
                },
                technology: {
                    en: 'Technology',
                    pt: 'Tecnologia'
                },
                module: {
                    en: 'Module/component',
                    pt: 'Módulo/component'
                },
                routine: {
                    en: 'Routine',
                    pt: 'Rotina'
                },
                aplication: {
                    en: 'Aplication',
                    pt: 'Aplicação'
                },
                transaction: {
                    en: 'Transaction',
                    pt: 'Transação'
                },
                clip: {
                    en: 'Clip',
                    pt: 'Clip'
                },
            },
            icons: {
                title: {
                    en: "Select icon",
                    pt: "Selecionar ícone"
                },
                confirm: {
                    en: "Confirm",
                    pt: "Confirmar"
                }
            },
            microservice: {
                title: {
                    en: 'MicroService',
                    pt: 'Micro Serviço'
                },
                business: {
                    en: 'Business',
                    pt: 'Empresa'
                },
                name: {
                    en: 'Name',
                    pt: 'Nome'
                },
                process: {
                    en: 'Process',
                    pt: 'Processo'
                },
                scope: {
                    en: 'Scope',
                    pt: 'Escopo'
                },
                description: {
                    en: 'Description',
                    pt: 'Descrição'
                },
                info: {
                    scope: {
                        en: 'It refers to the set of goals, objectives, activities, and deliverables that are defined and documented at the beginning of a project.',
                        pt: 'Isso se refere ao conjunto de metas, objetivos, atividades e entregas que são definidos e documentados no início de um projeto.'
                    }
                }
            },
            maturity: {
                title: {
                    en: 'Maturity',
                    pt: 'Maturidade'
                },
                maturity: {
                    en: 'Process maturity percentage',
                    pt: 'Percentual de maturidade do processo'
                }
            },
            attachments: {
                title: {
                    en: 'Attachments',
                    pt: 'Anexos'
                },
                validFormats: {
                    en: 'Allowed formats: pdf, ppt, pptx, pptm, doc, docx, odt, rtf, csv, txt, xml, json, xls, xlsx, jpeg, png',
                    pt: 'Formatos permitidos: pdf, ppt, pptx, pptm, doc, docx, odt, rtf, csv, txt, xml, json, xls, xlsx, jpeg, png',
                }
            },
            indicators: {
                title: {
                    en: 'Analytical',
                    pt: 'Analítico'
                },
                name: {
                    en: "Name",
                    pt: "Nome"
                },
                absolute: {
                    en: "Absolute",
                    pt: "Absoluto"
                },
                maximum: {
                    en: "Maximum",
                    pt: "Máximo"
                },
                minimum: {
                    en: "Minimum",
                    pt: "Mínimo"
                },
                average: {
                    en: "Average",
                    pt: "Médio"
                },
                frequency: {
                    en: "Frequency",
                    pt: "Frequência"
                },
                start_date: {
                    en: "Start date",
                    pt: "Data início"
                },
                end_date: {
                    en: "End date",
                    pt: "Data fim"
                },
                description: {
                    en: "Description",
                    pt: "Descrição"
                },
                new_indicator: {
                    en: "New indicator",
                    pt: "Novo indicador"
                },
                save_indicator: {
                    en: "Save indicator",
                    pt: "Salvar indicador"
                }
            },
            complements: {
                title: {
                    en: 'Chaining',
                    pt: 'Encadeamento'
                },
                new_complement: {
                    en: 'New chaining',
                    pt: "Novo encadeamento"
                },
                save_complement: {
                    en: "Save chaining",
                    pt: "Salvar encadeamento"
                },
                name: {
                    en: 'Name',
                    pt: 'Nome'
                },
                type: {
                    en: 'Type',
                    pt: 'Tipo'
                }
            },
            links: {
                title: {
                    en: 'Links',
                    pt: 'Links'
                },
                new_link: {
                    en: 'New link',
                    pt: "Novo link"
                },
                save_link: {
                    en: "Save link",
                    pt: "Salvar link"
                },
                name: {
                    en: 'Name',
                    pt: 'Nome'
                },
                type: {
                    en: 'Type',
                    pt: 'Tipo'
                },
                pastHere: {
                    en: 'Paste here',
                    pt: 'Cole aqui'
                },
                error: {
                    empty: {
                        en: 'Fill in the field first',
                        pt: 'Preencha o campo primeiro'
                    },
                    format: {
                        en: 'Format not accepted',
                        pt: 'Formato não aceito'
                    },
                    exists: {
                        en: 'Node is already linked',
                        pt: 'Nó já está vinculado'
                    },
                    same: {
                        en: 'Cannot link to the same node',
                        pt: 'Não pode fazer link com o próprio nó'
                    }
                }
            },
            configurations: {
                title: {
                    en: "FAQ",
                    pt: "FAQ"
                },
                new_question: {
                    en: "New question",
                    pt: "Nova pergunta"
                },
                save_question: {
                    en: "Save question",
                    pt: "Salvar pergunta"
                },
                question: {
                    en: "Question",
                    pt: "Pergunta"
                },
                answer: {
                    en: "Answer",
                    pt: "Resposta"
                },
                action: {
                    en: "Action",
                    pt: "Ação"
                },
                new_answer: {
                    en: "New answer",
                    pt: "Nova resposta"
                }
            },
            integrations: {
                title: {
                    en: "Integrations",
                    pt: "Integrações"
                },
                new_integration: {
                    en: "New integration",
                    pt: "Nova integração"
                },
                save_integration: {
                    en: "Save integration",
                    pt: "Salvar integração"
                },
                name: {
                    en: "Name",
                    pt: "Nome"
                },
                description: {
                    en: "Description",
                    pt: "Descrição"
                },
                type: {
                    en: "Type",
                    pt: "Tipo"
                },
                to: {
                    en: "To",
                    pt: "De"
                },
                from: {
                    en: "From",
                    pt: "Para"
                },
                script: {
                    en: "Technical script",
                    pt: "Script técnico"
                }
            },
            rules: {
                title: {
                    en: "Procedures",
                    pt: "Procedimentos"
                },
                new_rule: {
                    en: "New procedure",
                    pt: "Novo procedimento"
                },
                save_rule: {
                    en: "Save procedure",
                    pt: "Salvar procedimento"
                },
                name: {
                    en: "Name",
                    pt: "Nome"
                },
                description: {
                    en: "Description",
                    pt: "Descrição"
                },
                type: {
                    en: 'Type',
                    pt: 'Tipo'
                },
                titleNewType: {
                    en: 'New type',
                    pt: 'Novo tipo'
                },
                titleNewResponsibleOrganization: {
                    en: 'New responsible company',
                    pt: 'Nova empresa responsável'
                },
                errors: {
                    typeProcedure: {
                        en: "Procedure type already registered",
                        pt: "Tipo de procedimento já cadastrado"
                    },
                    typeAttachment: {
                        en: "Attachment type already registered",
                        pt: "Tipo de anexo já cadastrado"
                    },
                    typeFrequency: {
                        en: "Frequency type already registered",
                        pt: "Tipo de frequência já cadastrado"
                    }
                },

            },
            extendedAttributes: {
                title: {
                    en: "Extended Attributes",
                    pt: "Atributos Extendidos"
                },
                name: {
                    en: "Attribute name",
                    pt: "Nome do atributo"
                },
                content: {
                    en: "Content",
                    pt: "Conteúdo"
                },
                inclusion_date: {
                    en: "Inclusion date",
                    pt: "Data inc."
                },
                last_change_date: {
                    en: "Last change date",
                    pt: "Data ult. alt."
                },
                newAttribute: {
                    en: 'New attribute',
                    pt: 'Novo atributo'
                },
                createAttribute: {
                    en: 'Create attribute',
                    pt: 'Criar atributo'
                },
                type: {
                    en: 'Type',
                    pt: 'Tipo'
                },
                possibleValues: {
                    en: 'Possible values',
                    pt: 'Valores possíveis'
                },
                placeholderValue: {
                    en: 'Value 01; Value 02; Value 03; ...; Value N',
                    pt: 'Valor 01; Valor 02; Valor 03; ...; Valor N'
                },
                extended_attribute_already_registered: {
                    en: "Extended attribute already registered",
                    pt: "Atributo extendido já cadastrado"
                }
            },
            transactions: {
                title: {
                    en: "Skills",
                    pt: "Competências"
                },
                new_transaction: {
                    en: "New transaction",
                    pt: "Nova transação"
                },
                save_transaction: {
                    en: "Save transaction",
                    pt: "Salvar transação"
                },
                name: {
                    en: "Name",
                    pt: "Nome"
                },
                description: {
                    en: "Description",
                    pt: "Descrição"
                }
            },
            project: {
                title: {
                    en: "Project",
                    pt: "Projeto"
                },
                project: {
                    en: 'Level 1',
                    pt: 'Nível 1'
                },
                subproject: {
                    en: 'Level 2',
                    pt: 'Nível 2'
                },
                table: {
                    task_name: {
                        en: "Task name",
                        pt: "Nome da tarefa"
                    },
                    concluded: {
                        en: '% concluded',
                        pt: '% concluído'
                    },
                    plan: {
                        en: '% planned to measurement',
                        pt: '% planejado até medição'
                    },
                    duration: {
                        en: 'Duration',
                        pt: 'Duração'
                    },
                    start_date: {
                        en: 'Start date',
                        pt: 'Data início'
                    },
                    end_date: {
                        en: 'End date',
                        pt: 'Data fim'
                    },
                    name_task_null: {
                        en: 'Tasks with an empty name will not be saved',
                        pt: 'Tarefas com nome vazio não serão salvas'
                    },
                    action: {
                        en: 'Action',
                        pt: 'Ação'
                    },
                    guideline: {
                        en: 'Configure Project Guideline',
                        pt: 'Configure o Guideline de Projeto'
                    },
                }
            },
            accessUser: {
                title: {
                    en: 'Link users',
                    pt: 'Vincular usuários'
                },
                applyInCascade: {
                    en: 'Apply in cascade',
                    pt: 'Aplicar em cascata',
                },
                applyInCascadeTooltip: {
                    en: 'Apply to all levels below',
                    pt: 'Aplicar a todos os níveis abaixo'
                },
                user: {
                    en: 'User',
                    pt: 'Usuário'
                },
            }
        }
    },
    corporation: {
        content: {
            top: {
                en: 'Organization',
                pt: 'Organização'
            },
        },
        dimension: {
            title: {
                en: 'Dimensions',
                pt: 'Dimensões'
            },
            strategy: {
                en: 'Strategy',
                pt: 'Estratégia'
            },
            people: {
                en: 'Organizational structure',
                pt: 'Estrutura organizacional',
            },
            technology: {
                en: 'Technology',
                pt: 'Tecnologia'
            },
            business: {
                en: 'Business',
                pt: 'Empresa'
            },
            skills: {
                en: "Skills",
                pt: "Competências"
            }
        },
        modal: {
            address: {
                en: 'Address',
                pt: 'Endereço'
            },
            edit: {
                en: 'Edit Organization',
                pt: 'Editar Organização'
            },
            create: {
                en: 'Create Organization',
                pt: 'Criar Organização'
            },
            principal: {
                en: 'Principal',
                pt: 'Principal'
            },
            newType: {
                title: {
                    en: 'Create Organization Type',
                    pt: 'Criar Tipo de Organização'
                },
                en: 'New Type',
                pt: 'Novo Tipo'
            },
            acronym: {
                en: 'Acronym',
                pt: 'Sigla'
            },
            newSegment: {
                title: {
                    en: 'Create Business Segment',
                    pt: 'Criar Segmento'
                },
                en: 'New Business Segment',
                pt: 'Novo Segmento'
            },
            stateRegistration: {
                en: 'State Registration',
                pt: 'Registro Estadual'
            },
            municipalRegistration: {
                en: 'Municipal Registration',
                pt: 'Registro Municipal'
            },
            telephone: {
                en: 'Telefone',
                pt: 'Telefone'
            },
            referenceParent: {
                en: 'Reference Parent',
                pt: 'Referência Pai'
            },
            record: {
                en: 'Record',
                pt: 'CNPJ'
            },
            corporationName: {
                en: 'Name',
                pt: 'Nome'
            },
            fantasyName: {
                en: 'Fantasy name',
                pt: 'Nome fantasia'
            },
            type: {
                en: 'Type',
                pt: 'Tipo'
            },
            followUp: {
                en: 'Business segment',
                pt: 'Segmento comercial'
            },
            openingDate: {
                en: 'Opening date',
                pt: 'Data de abertura'
            },
            domain: {
                en: 'Domain',
                pt: 'Domínio'
            },
            site: {
                en: 'Site',
                pt: 'Site'
            },
            status: {
                en: 'Status',
                pt: 'Status'
            },
            zipCode: {
                en: 'Zip code',
                pt: 'CEP'
            },
            country: {
                en: 'Country',
                pt: 'País'
            },
            state: {
                en: 'State',
                pt: 'Estado'
            },
            city: {
                en: 'City',
                pt: 'Cidade'
            },
            neighborhood: {
                en: 'Neighborhood',
                pt: 'Bairro'
            },
            publicPlace: {
                en: 'Public place',
                pt: 'Logradouro'
            },
            number: {
                en: 'Number',
                pt: 'Número'
            },
            complement: {
                en: 'Complement',
                pt: 'Complemento'
            },
            info: {
                type: {
                    en: "Choose Organization Type",
                    pt: "Selecione o Tipo da Organização"
                },
                followUp: {
                    en: "Choose Business Segment",
                    pt: "Selecione o Segmento da Organização"
                },
                parent: {
                    en: "Choose Organization Parent",
                    pt: "Selecione a Organização Pai"
                }
            },
            delete: {
                title: {
                    en: 'Attention!',
                    pt: 'Atenção!'
                },
                content: {
                    en: 'Do you really want to delete the component?',
                    pt: 'Você realmente deseja excluir o componente?'
                },
                cancel: {
                    en: 'Cancel',
                    pt: 'Cancelar'
                },
                confirm: {
                    en: 'Confirm',
                    pt: 'Confirmar'
                }
            }
        }
    },

    clipboard: {
        title: {
            en: "Processes on the clipboard",
            pt: "Processos na área de transferência"
        },
        description: {
            en: "Processes remain on the clipboard for 24 hours",
            pt: "Processos permanecem na área de transferência por 24 horas"
        },
        link: {
            en: "Link copied to clipboard successfully!",
            pt: "Link copiado para área de transferência com sucesso!"
        },
        send_to: {
            en: "Send to",
            pt: "Enviar para"
        },
        send_to_business_solutions: {
            en: "Send to Business Solutions",
            pt: "Enviar para Business Solutions"
        },
        send_to_crm_tree: {
            en: "Send to CRM Tree",
            pt: "Enviar para árvore de CRM"
        }
    },

    users: {
        content: {
            top: {
                en: 'Users',
                pt: 'Usuários'
            },
            active: {
                en: 'Active users',
                pt: 'Usuários ativos'
            },
            inactive: {
                en: 'Inactive users',
                pt: 'Usuários inativos'
            },
            registred: {
                en: 'Registered users',
                pt: 'Usuários registrados'
            },
            title: {
                en: 'User table',
                pt: 'Tabela de usuários'
            },
            userList: {
                en: 'User list',
                pt: 'Tabela de usuários'
            },
            profile: {
                en: 'Profile',
                pt: 'Perfis'
            },
            approval: {
                en: 'Approval list',
                pt: 'Lista de aprovação'
            },
            table: {
                name: {
                    en: 'Name',
                    pt: 'Nome'
                },
                email: {
                    en: 'Email',
                    pt: 'E-mail'
                },
                profile: {
                    en: 'Profile',
                    pt: 'Perfil'
                },
                corporation: {
                    en: 'Organization',
                    pt: 'Organização'
                },
                status: {
                    en: 'Status',
                    pt: 'Status',
                    true: {
                        en: 'Active',
                        pt: 'Ativo',
                    },
                    false: {
                        en: 'Inactive',
                        pt: 'Inativo',
                    },
                    waiting: {
                        en: 'Waiting',
                        pt: 'Aguardando',
                    }
                },
                telephone: {
                    en: 'Telefone',
                    pt: 'Telefone'
                },
                approver: {
                    en: 'Approver',
                    pt: 'Aprovador'
                },
                admin: {
                    en: 'Administrator',
                    pt: 'Administrador',
                    master: {
                        en: 'Administrator Master',
                        pt: 'Administrator Master',
                    },
                    environment: {
                        en: 'Administrator Environment',
                        pt: 'Administrator Environment',
                    },
                    others: {
                        en: 'Comum User',
                        pt: 'Comum User',
                    },
                },
            },
        },
        modal: {
            approve: {
                en: "Approve",
                pt: "Aprovar"
            },
            refuse: {
                en: "Refuse",
                pt: "Recusar"
            },
            create: {
                title: {
                    en: 'Create user',
                    pt: 'Criar Usuário'
                },
                name: {
                    en: 'Name',
                    pt: 'Nome'
                },
                last_name: {
                    en: 'Last Name',
                    pt: 'Último Nome'
                },
                email: {
                    en: 'Corporate email',
                    pt: 'E-mail Corporativo '
                },
                telephone: {
                    en: 'Telefone',
                    pt: 'Telefone'
                },
                document: {
                    en: 'Document',
                    pt: 'Documento'
                },
                profile: {
                    en: 'Profile',
                    pt: 'Perfil'
                },
                profile_corporation: {
                    en: 'Organization profile',
                    pt: 'Perfil de organização'
                },
                profile_environment:{  
                    en: 'Environment profile', 
                    pt: 'Perfil de ambiente'
                },
                profile_master: {
                    en: 'Master Profile',
                    pt: 'Perfil Master'
                },
                corporation: {
                    en: 'Organization',
                    pt: 'Organização'
                },
                status: {
                    en: 'Status',
                    pt: 'Status'
                },
                administrator: {
                    en: "Environment Administrator",
                    pt: "Administrador do Ambiente"
                }
            },
            edit: {
                title: {
                    en: 'Edit User',
                    pt: 'Editar Usuário',

                    one: {
                        en: 'Edit User',
                        pt: 'Editar Usuário'
                    },
                    multiple: {
                        en: 'Edit Users',
                        pt: 'Editar Usuários'
                    }
                }
            },
            view: {
                title: {
                    en: 'View User',
                    pt: 'Visualizar Usuário'
                }
            }
        }
    },

    log: {
        en: 'Activities log',
        pt: 'Log de atividades',

        selectInstance: {
            en: 'Must be select an instance',
            pt: 'Deve selecionar uma instância'
        },
        selectCorporate: {
            en: 'Must be select a organization',
            pt: 'Deve selecionar uma organização'
        },
        interval: {
            en: 'Interval',
            pt: 'Intervalo'
        }
    },

    guideline: {
        en: "Guideline business tree",
        pt: "Guideline árvore de negócio",

        banner: {
            en: 'The Guideline allows for the customization of functionalities to meet your business needs. At this stage, you can adjust the Business Tree tool. Its main goal is to accommodate and organize the processes of a organization, enabling management and strategic insights. Create the entities corresponding to each level of a tree.',
            pt: "O Guideline permite parametrização de funcionalidades para atender às necessidades do seu negócio. Nessa etapa, poderá ser ajustada a ferramenta Árvore de Negócio. Seu principal objetivo é comportar e organizar os processos de uma organização, sendo possível administrar e ter insights estratégicos. Crie as entidades referente a cada nível de uma árvore"
        },

        mandatory: {
            en: 'Mandatory',
            pt: "Obrigatório"
        },

        level: {
            en: 'Level',
            pt: "Nível"
        },

        entity: {
            en: "Entity",
            pt: "Entidade"
        },

        level_composition: {
            en: 'Level composition',
            pt: 'Composição do nível'
        },

        add_level: {
            en: "Parameterize level",
            pt: "Parametrizar nível"
        },

        settings_panel: {
            en: "Settings panel",
            pt: "Painel de configurações"
        },

        import: {
            en: "Do you want to import a guideline from another organization or use the default one?",
            pt: "Deseja importar um guideline de outra organização ou usar o padrão?"
        },

        form: {
            level_1: {
                en: 'Level 1 of your process structure should represent a macro grouping (journey, value chain, etc.), serving as a foundation for organizing and analyzing information. In this fundamental layer, the broadest categories encompassing the entire set of processes will be defined.',
                pt: 'O Nível 1 da sua estrutura de processos deve representar um agrupamento macro (jornada, cadeia de valor etc.), servindo como base para a organização e análise das informações. Nessa camada fundamental, serão definidas as categorias mais amplas que englobam o conjunto de processos como um todo.'
            },
            level_2: {
                en: 'Level 2 of your process structure should represent a broad view of a stage from Level 1, typically encompassing more than one sector, department, and function.',
                pt: 'O Nível 2 da sua estrutura de processos deve representar uma visão ampla de uma etapa do Nível 1, normalmente abrangendo mais de um setor, departamento e função.'
            },
            level_3: {
                en: 'Level 3 of your process structure should represent a broad view of a sub-stage from Level 2, typically encompassing a second or third-level functional area of the organizational chart.',
                pt: 'O Nível 3 da sua estrutura de processos deve representar uma visão ampla de uma sub etapa do Nível 2, normalmente abrangendo uma área funcional de segundo ou terceiro nível do organograma.'
            },
            level_4: {
                en: 'Level 4 of your process structure should represent a view of a set of interlinked tasks from Level 3.',
                pt: 'O Nível 4 da sua estrutura de processos deve representar uma visão de um conjunto de tarefas encadeadas do Nível 3.'
            },
            level_5: {
                en: 'Level 5 of your process structure should represent a view of a set of interlinked tasks from Level 4.',
                pt: 'O Nível 5 da sua estrutura de processos deve representar uma visão de um conjunto de tarefas encadeadas do Nível 4.'
            },
            level_6: {
                en: 'Level 6 of your process structure should represent a detailed view of individual tasks within the sets defined in Level 5.',
                pt: 'O Nível 6 da sua estrutura de processos deve representar uma visão detalhada das tarefas individuais dentro dos conjuntos definidos no Nível 5.'
            },
            level_7: {
                en: 'Level 7 of your process structure should represent a more granular view of specific activities within the tasks defined in Level 6.',
                pt: 'O Nível 7 da sua estrutura de processos deve representar uma visão mais granular das atividades específicas dentro das tarefas definidas no Nível 6.'
            },
            level_8: {
                en: 'Level 8 of your process structure should represent the step-by-step actions required to complete the activities defined in Level 7.',
                pt: 'O Nível 8 da sua estrutura de processos deve representar as ações passo a passo necessárias para completar as atividades definidas no Nível 7.'
            },
            level_9: {
                en: 'Level 9 of your process structure should represent a detailed view of the execution procedures for the actions defined in Level 8.',
                pt: 'O Nível 9 da sua estrutura de processos deve representar uma visão detalhada dos procedimentos de execução para as ações definidas no Nível 8.'
            },
            level_10: {
                en: 'Level 10 of your process structure should represent the fine-grained specifications and standards for the procedures defined in Level 9.',
                pt: 'O Nível 10 da sua estrutura de processos deve representar as especificações e padrões detalhados para os procedimentos definidos no Nível 9.'
            },
            name: {
                en: "Entity name",
                pt: "Nome da entidade"
            },
            acronym: {
                en: "Acronym",
                pt: "Sigla"
            },
            obligatoriness: {
                en: "Obligatoriness",
                pt: 'Obrigatoriedade'
            },
            form_areas: {
                en: 'Form areas',
                pt: "Áreas do formulário"
            },
            display: {
                en: 'display',
                pt: "Exibir"
            }
        }
    },
    choseCurrent: {
        title: {
            en: 'Do you want to change the main tree?',
            pt: 'Deseja trocar a árvore principal?'
        }
    },
    notFound: {
        text: {
            en: 'The route could not be found',
            pt: 'A rota não pôde ser encontrada'
        },
        n404: {
            en: '404',
            pt: '404'
        }
    },
    technologies: {
        en: "Technologies",
        pt: "Tecnologias",

        tree: {
            en: "Technology tree",
            pt: "Árvore de tecnologias"
        },
        add: {
            en: "New",
            pt: "Novo"
        },
        edit: {
            en: "Edit",
            pt: "Editar"
        },
        view: {
            en: "View",
            pt: "Visualizar"
        },
        delete: {
            en: "Delete",
            pt: "Deletar"
        },
        name: {
            en: "Name",
            pt: "Nome"
        },
        specification: {
            en: 'Specifications',
            pt: 'Especificações'
        },
        landscape: {
            en: 'Technology landscape',
            pt: 'Natureza da tecnologia'
        },
        version: {
            en: 'Version',
            pt: 'Versão'
        },
        manufacturer: {
            en: 'Manufacturer',
            pt: 'Fabricante'
        },
        date_installation: {
            en: 'Date installation',
            pt: 'Data instalação'
        },
        name_module: {
            en: 'Name module/component',
            pt: 'Nome módulo/componente'
        },
        id_trasaction: {
            en: 'Trasaction id',
            pt: 'Id da transação'
        },
        new_transaction: {
            en: "New transaction registered with success",
            pt: "Nova transação cadastrada com sucesso"
        },
        new_transaction_error: {
            en: "Error in saved new transaction",
            pt: "Erro ao cadastrar nova transação"
        },
        title_new_landscape: {
            en: 'New technology landscape',
            pt: "Nova natureza da tecnologia"
        },
        new_landscape: {
            en: "Name technology landscape",
            pt: "Nome da natureza da tecnologia"
        },
        errors: {
            landscape_already_registered: {
                en: "Landscape technology already registered",
                pt: "Natureza da tecnologia já cadastrada"
            }
        },
        import: {
            en: 'Would you like to import a technology tree from another organization?',
            pt: 'Deseja importar uma árvore de tecnologias de outra organização?'
        },
        name_platform: {
            en: 'Platform/installation/system name',
            pt: 'Nome plataforma/instalação/sistema'
        },
        name_technology_null: {
            en: 'Technologies with an empty name will not be saved',
            pt: 'Tecnologias com nome vazio não serão salvas'
        },
        technologies_empty: {
            en: 'Configure the Technologies initially',
            pt: 'Configure as Tecnologias primeiro'
        }
    },
    personas: {
        en: 'Organizational structure',
        pt: 'Estrutura organizacional',

        tree: {
            en: 'Organizational structure tree',
            pt: 'Árvore da estrutura organizacional',
        },
        add: {
            en: "New",
            pt: "Nova"
        },
        edit: {
            en: "Edit",
            pt: "Editar"
        },
        view: {
            en: "View",
            pt: "Visualizar "
        },
        delete: {
            en: "Delete",
            pt: "Deletar"
        },
        name: {
            en: "Name",
            pt: "Nome"
        },
        cost: {
            en: "FTE Cost",
            pt: "Custo FTE"
        },
        cost_min: {
            en: "FTE Cost",
            pt: "Custo FTE Mínimo"
        },
        cost_max: {
            en: "FTE Cost",
            pt: "Custo FTE Máximo"
        },
        history: {
            en: 'History',
            pt: 'Histórico'
        },
        is_current: {
            en: 'Is current',
            pt: 'Atual'
        },
        start_date: {
            en: 'Start date',
            pt: 'Data de início'
        },
        end_date: {
            en: 'End date',
            pt: 'Data de término'
        },
        user: {
            en: 'User',
            pt: 'Usuário'
        },
        inclusion_date: {
            en: 'Inclusion date',
            pt: 'Data de inclusão'
        },
        yes: {
            en: 'Yes',
            pt: 'Sim'
        },
        no: {
            en: 'No',
            pt: 'Não'
        },
        fte: {
            en: 'Amount of fte',
            pt: "Quantidade de FTE"
        },
        choose_reference: {
            en: 'Change reference',
            pt: 'Trocar referência',

            label: {
                en: 'Choose to view the environment tree or the organization tree',
                pt: 'Escolha para visualizar a árvore do ambiente ou a árvore da organização'
            },  
            confirm: {
                en: 'Do you want to change the reference of the organizational structure tree?',
                pt: 'Deseja alterar a referência da árvore de estrutura organizacional?'
            },
            subtitle: {
                en: 'This change will impact the Business Tree and the Price Formation services.',
                pt: 'Essa mudança impactará a Árvore de Negócios e os serviços de Formação de Preço.'
            },
            environment: {
                en: 'Environment',
                pt: 'Ambiente'
            }
        },
        type: {
            en: 'Type',
            pt: "Tipo"
        },
        skills: {
            en: "Skills",
            pt: "Competências"
        },
        specialties: {
            en: "Specialties",
            pt: "Especialidades"
        },
        import: {
            en: 'Would you like to import a organizational structure tree from another organization?',
            pt: 'Deseja importar uma árvore de estrutura organizacional de outra organização?'
        },
        level: {
            en: 'Level',
            pt: 'Nível'
        },
        seniority: {
            en: "Seniority",
            pt: "Senioridade"
        },
        newSeniorityLevel: {
            en: 'New seniority/level',
            pt: 'Nova senioridade/nível'
        }
    },
    project_guideline: {
        en: "Project guideline",
        pt: "Guideline de projeto",

        tree: {
            en: "Project guideline tree",
            pt: "Árvore de guideline de projeto"
        },
        add: {
            en: "New",
            pt: "Novo"
        },
        edit: {
            en: "Edit",
            pt: "Editar"
        },
        view: {
            en: "View",
            pt: "Visualizar"
        },
        delete: {
            en: "Delete",
            pt: "Deletar"
        },
        name: {
            en: "Name",
            pt: "Nome"
        },
        import: {
            en: 'Would you like to import a project guideline tree from another organization?',
            pt: 'Deseja importar uma árvore de guideline project de outra organização?'
        },
        type: {
            en: 'Type',
            pt: 'Tipo'
        },
        objective: {
            en: 'Description / objective',
            pt: 'Descrição / objetivo'
        },
        alert: {
            en: 'name',
            pt: 'nome'
        },
        iterative: {
            en: 'Iterative',
            pt: "Iterativo"
        },
        active: {
            en: 'Active',
            pt: 'Ativo'
        },
        title_new_type: {
            en: 'New project type',
            pt: "Novo tipo de projeto"
        },
        new_type: {
            en: "Name project type",
            pt: "Nome do tipo de projeto"
        },
        errors: {
            type_already_registered: {
                en: "Project type already registered",
                pt: "Tipo de projeto já cadastrado"
            }
        },
    },
    new_transaction: {
        title: {
            en: 'New transaction',
            pt: 'Nova transação'
        }
    }
}
